export default __webpack_public_path__ + "static/media/gallery-wip-ammo-port-enclosure-box_04.b09a04e3.jpg";